import type { Workspace } from "@/types/common";

/**
 * Every account has a main workspace. Querying the main workspace returns a null workspace ID because you typically cannot return these details via the API.
 */
export const mainWorkspace = {
  id: 1,
  name: "Main",
};

export const getWorkspace = (workspace: Workspace) => {
  return (
    workspace || {
      id: `${mainWorkspace.id}`,
      name: mainWorkspace.name,
      settings: {
        icon: {
          image: null,
          color: null,
        },
      },
    }
  );
};
